import { LoadingSpinnerPageState } from '@/ui/composites/LoadingSpinnerPageState';
import type { RecoveryUxPhase } from './recoveryUxPhase';
import type { ReactElement } from 'react';

export const RecoveryStatusPanel = ({ phase }: { phase: RecoveryUxPhase }): ReactElement | null => {
  if (phase === 'silent') return null;

  return <LoadingSpinnerPageState message="Authenticating user..." />;
};
